import { Box, Button, TextField, Typography } from "@mui/material";

import Grid from "@mui/material/Grid";

import React, { useEffect, useState } from "react";
import {} from "../../utils/utils";
// import Youtube from '../assets/img/icon/youtube.png'
import { useSelector } from "react-redux";
// import { GetBussiness, UpdateBusiness } from "./myBusinessApi";
import DeleteIcon from "@mui/icons-material/Delete";

import { formDataFN, swalAlertPopProps } from "../../utils/commonUtils";
// import { validationsSubmits } from "./myBusinessValidationFunctions";
import {
  getInstitute,
  institueAdd,
  institueUpdate,
} from "../myInstitute/instituteApi";
import AddModal from "./AddModal";
import {
  franchiseSupporttAdd,
  franchiseSupportUpdate,
  getFranchiseSupport,
} from "./franchiseAPI";
import ConfirmDelete from "../Jobs/confirmDelete";
import Heading from "../../common/Heading";
// import { getInstitute, institueAdd, institueUpdate } from "./instituteApi";

export default function FranchiseSupport(instituteId) {
  const struct = {
    // id: 4,
    title: "",
    territory: "",
    infrastructure: [],
    investmentCosts: [],
    royalties: [],
    staff: [],
  };
  const [open, setOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("");
  const [editIndex, setEditIndex] = useState(null);
  const [institute, setInstitute] = useState({ ...struct });
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteType, setDeleteType] = useState("");
  const userDetail = useSelector((state) => state.reducer.userDetail);

  let val = userDetail?.profileId?.split("?")[1];
  let billerId = Number(val?.split("=")[1]?.replace(/\D/g, ""));

  const getData = async () => {
    const payload = { billerId: billerId || userDetail?.userMasterId };

    getFranchiseSupport(payload, (res) => {
      const obj = res?.data?.data?.list?.[0];
      console.log("suppp", obj);
      if (!obj) {
        // NO DATA → RESET FORM FOR ADD
        setInstitute({ ...struct, billerId });
        return;
      }
      setInstitute(obj);

      // console.log(obj);
    });

    // console.log("ll", institute?.instituteName);
  };
  const handleDeleteEducation = (section, index) => {
    if (!section || index === null) return;
    const updatedEducation = institute[section]?.filter((_, i) => i !== index);

    setInstitute((prev) => ({
      ...prev,
      [section]: updatedEducation,
    }));

    franchiseSupportUpdate({
      ...institute,
      [section]: updatedEducation,
    });
  };
  const handleSave = (data) => {
    if (!activeSection) return;

    setInstitute((prev) => ({
      ...prev,
      [activeSection]: [...(prev[activeSection] || []), { value: data.value }],
    }));
  };
  const handleUpdate = (data) => {
    if (editIndex === null || !activeSection) return;

    setInstitute((prev) => {
      const updatedArray = [...prev[activeSection]];
      updatedArray[editIndex] = {
        ...updatedArray[editIndex],
        value: data.value,
      };

      return {
        ...prev,
        [activeSection]: updatedArray,
      };
    });

    setEditIndex(null);
  };

  const submit = async () => {
    const payload = {
      ...institute,
    };

    if (!institute?.id) {
      await franchiseSupporttAdd(payload, () => {
        getData();
      });
    } else {
      await franchiseSupportUpdate(payload, () => {
        getData();
      });
    }
  };
  useEffect(() => {
    getData();
  }, []);
  const labelStyle1 = {
    fontWeight: 600,
    color: "#000",
    fontSize: { xs: "12px", sm: "13px", md: "15px" },
    whiteSpace: "nowrap",
  };
  // return <h1>fet</h1>
  return (
    <Grid
      container
      px={{ sm: 4, xs: 2 }}
      pb={4}
      sx={{
        paddingTop: "15px",
        backgroundColor: "#E3E3FF",
        minHeight: "100vh",
      }}
    >
      {/* <DynamicBreadcrumbs /> */}

      <Grid item xs={12}>
        <Heading name="Franchise Support" />

        {/* <Grid container>
          <Grid
            item
            xs={12}
            sx={{
              background:
                "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
              padding: "10px 15px",
              mt: { sm: "10px", xs: "1px" },
              borderRadius: "5px",
              color: "#01008B", // optional text color
              textAlign: "left",
              marginBottom: "20px",
              fontFamily: "'Montserrat', sans-serif",
              fontSize: { xs: "12px", sm: "13px", md: "15px" },

              fontWeight: 500,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontSize: { xs: "13px", sm: "14px", md: "20px" },
              }}
            >
              Franchise Support
            </Typography>
          </Grid>
        </Grid> */}
        <Grid
          container
          spacing={1}
          sx={{
            margin: 0,
            padding: { xs: "0px", sm: "20px" },
            borderRadius: "10px",
            backgroundColor: "#fff",
            maxHeight: "70vh",
            overflow: "auto",
            pr: { xs: 1, sm: 4 },
          }}
        >
          {/* .. */}
          <Grid item xs={12}>
            <Box mb={2}>
              {/* Header */}
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb={0.5}
              >
                <Typography
                  sx={{
                    fontSize: { xs: "12px", sm: "14px", md: "15px" },
                    fontWeight: 600,
                    color: "#000",
                  }}
                >
                  Franchise will provide
                </Typography>

                <Typography
                  sx={{
                    fontSize: { xs: "12px", sm: "16px" },
                    fontWeight: 700,
                    color: "#01008B",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setActiveSection("willProvide");
                    setOpen(true);
                  }}
                >
                  Add +
                </Typography>
              </Box>
              <Box
                sx={{
                  border: "1.5px solid #01008B",
                  borderRadius: "8px",
                  p: 2,
                  // pt: 4,

                  position: "relative",
                }}
              >
                {" "}
                <Grid
                  container
                  spacing={1}
                  //   sx={{ mt: 1, p: 2 }}
                  justifyContent="center"
                >
                  {institute?.willProvide?.map((item, index) => {
                    return (
                      <Grid item xs={12} md={6}>
                        <Box
                          sx={{
                            p: 2,
                            border: "1.5px solid #01008B",
                            borderRadius: "8px",
                            position: "relative",
                            backgroundColor: "#fff",
                          }}
                        >
                          <DeleteIcon
                            sx={{
                              position: "absolute",
                              top: 10,
                              right: 10,
                              color: "#01008B",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setDeleteType("willProvide");
                              setDeleteIndex(index);
                              setConfirmOpen(true);
                            }}
                          />

                          <Box
                            sx={{
                              display: "grid",
                              gridTemplateColumns: "140px 1fr",
                              rowGap: "10px",
                            }}
                          >
                            <Typography sx={labelStyle1}>
                              {item?.value}
                            </Typography>
                          </Box>

                          <Button
                            fullWidth
                            variant="contained"
                            sx={{
                              backgroundColor: "#01008B",
                              fontWeight: 600,
                              mt: 2,
                              textTransform: "none",
                            }}
                            onClick={() => {
                              setActiveSection("willProvide");
                              setOpen(true);
                              setEditIndex(index);
                            }}
                          >
                            Edit
                          </Button>
                        </Box>
                      </Grid>
                    );
                  })}
                </Grid>
              </Box>
            </Box>{" "}
          </Grid>
          <Grid item xs={12}>
            <Box mb={2}>
              {/* Header */}
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb={0.5}
              >
                <Typography
                  sx={{
                    fontSize: { xs: "12px", sm: "14px", md: "15px" },
                    fontWeight: 600,
                    color: "#000",
                  }}
                >
                  ROI & Profit
                </Typography>

                <Typography
                  sx={{
                    fontSize: { xs: "12px", sm: "16px" },
                    fontWeight: 700,
                    color: "#01008B",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setActiveSection("roIs");
                    setOpen(true);
                  }}
                >
                  Add +
                </Typography>
              </Box>
              <Box
                sx={{
                  border: "1.5px solid #01008B",
                  borderRadius: "8px",
                  p: 2,
                  // pt: 4,

                  position: "relative",
                }}
              >
                {" "}
                <Grid
                  container
                  spacing={1}
                  //   sx={{ mt: 1, p: 2 }}
                  justifyContent="center"
                >
                  {institute?.roIs?.map((item, index) => {
                    return (
                      <Grid item xs={12} md={6}>
                        <Box
                          sx={{
                            p: 2,
                            border: "1.5px solid #01008B",
                            borderRadius: "8px",
                            position: "relative",
                            backgroundColor: "#fff",
                          }}
                        >
                          <DeleteIcon
                            sx={{
                              position: "absolute",
                              top: 10,
                              right: 10,
                              color: "#01008B",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setDeleteType("roIs");
                              setDeleteIndex(index);
                              setConfirmOpen(true);
                            }}
                          />

                          <Box
                            sx={{
                              display: "grid",
                              gridTemplateColumns: "140px 1fr",
                              rowGap: "10px",
                            }}
                          >
                            <Typography sx={labelStyle1}>
                              {item?.value}
                            </Typography>
                          </Box>

                          <Button
                            fullWidth
                            variant="contained"
                            sx={{
                              backgroundColor: "#01008B",
                              fontWeight: 600,
                              mt: 2,
                              textTransform: "none",
                            }}
                            onClick={() => {
                              setActiveSection("roIs");
                              setOpen(true);
                              setEditIndex(index);
                            }}
                          >
                            Edit
                          </Button>
                        </Box>
                      </Grid>
                    );
                  })}
                </Grid>
              </Box>
            </Box>{" "}
          </Grid>
          {/* .Button */}
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "60%",
                mx: "auto",
              }}
            >
              <Button
                type="submit"
                fullWidth
                variant="contained"
                onClick={submit}
                sx={{
                  mt: 3,
                  mb: 2,
                  py: 1,
                  fontSize: { xs: "12px", sm: "13px", md: "16px" },
                  fontWeight: 500,
                  fontFamily: "'Montserrat', sans-serif",
                }}
              >
                Save
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Grid>
      <AddModal
        open={open}
        handleClose={() => {
          setOpen(false);
          setEditIndex(null);
        }}
        activeSection={activeSection}
        onSave={(data) => {
          if (editIndex !== null) {
            handleUpdate(data); // UPDATE
          } else {
            handleSave(data); // ADD
          }
        }}
        editValue={
          editIndex !== null
            ? institute?.[activeSection]?.[editIndex]?.value
            : ""
        }
      />

      <ConfirmDelete
        open={confirmOpen}
        title={
          `Do you want to remove ${deleteType} Detail?`
          // deleteType === "infrastructure"
          //   ? "Do you want to remove infrastructure Detail?"
          //   : "Do you want to remove Experience Detail?"
        }
        onClose={() => {
          setConfirmOpen(false);
          setDeleteIndex(null);
          setDeleteType("");
        }}
        onConfirm={() => {
          handleDeleteEducation(deleteType, deleteIndex);

          setConfirmOpen(false);
        }}
      />
    </Grid>
  );
}
